import React from "react";
import styles from "./Header.module.scss";
import { useNavigate } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import { RiLayoutGridFill } from "react-icons/ri";

function Header({ title }) {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      <div className={styles.headerBack} onClick={() => navigate(-1)}>
        <MdArrowBackIosNew color="#E6BE02" size={25} />
      </div>

      <div className={styles.headerTitle}>
        <span>{title}</span>
      </div>

      <div
        onClick={() => navigate("/profile")}
        className={styles.headerProfile}
      >
        <RiLayoutGridFill color="#E6BE02" size={25} />
      </div>
    </div>
  );
}

export default Header;